import React from "react";

import WhatWeDo1 from "../Assets/what-we-do1.jpg";
import WhatWeDo2 from "../Assets/what-we-do2.jpg";
import WhatWeDo3 from "../Assets/what-we-do3.jpg";
import { useStateContext } from "../contexts/ContextProvider";

const WhatWeDo = ({ hideOnMobile }) => {

  const { handleShowContact } = useStateContext();


  return (
    <>
      <section
        className={hideOnMobile ? "d-none d-lg-block" : ""}

        id="section7"
      >
        <div className="what_we_do" id="what-we-do">
          <div className="heading">
            <h3>
              What <span>We Do</span>?
            </h3>
            <h5>Our Expertise in eLearning Development</h5>
          </div>
          <div className="what_we_do_list">
            <div className="flex-row">
              <div className="row">
                <div className="col-xl-4 col-lg-4">
                  <div className="item">
                    <img src={WhatWeDo1} alt="" />
                    <div className="overlay"></div>
                    <div className="content">
                      <h6>Custom eLearning Development</h6>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-4">
                  <div className="item">
                    <img src={WhatWeDo2} alt="" />
                    <div className="overlay"></div>
                    <div className="content">
                      <h6>Interactive Simulations</h6>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-4">
                  <div className="item">
                    <img src={WhatWeDo3} alt="" />
                    <div className="overlay"></div>

                    <div className="content">
                      <h6>Compliance & Safety Training</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex-col"></div>
          </div>
          <button className="action" onClick={handleShowContact}>Let’s Get In Touch</button>
        </div>
      </section>
    </>
  );
};

export default WhatWeDo;
